import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetData } from 'redux/actions/FinancialModelActions';

const Logout = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  return (
    <div>
      <h1>Logout</h1>
    </div>
  );
};

export default Logout;
